import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';

const NotFound = lazy(() => import('../pages/NotFound'));
const MedicalGloves = lazy(() => import('../pages/medical-gloves/page'));
const FoodGradeGloves = lazy(() => import('../pages/food-grade-gloves/page'));
const LabGloves = lazy(() => import('../pages/lab-gloves/page'));
const IndustrialGloves = lazy(() => import('../pages/industrial-gloves/page'));
const BulkWholesale = lazy(() => import('../pages/bulk-wholesale/page'));
const RequestQuote = lazy(() => import('../pages/request-quote/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy-policy/page'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="w-10 h-10 border-4 border-brand-green border-t-transparent rounded-full animate-spin" />
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/medical-gloves',
    element: (
      <Suspense fallback={<PageLoader />}>
        <MedicalGloves />
      </Suspense>
    ),
  },
  {
    path: '/food-grade-gloves',
    element: (
      <Suspense fallback={<PageLoader />}>
        <FoodGradeGloves />
      </Suspense>
    ),
  },
  {
    path: '/lab-gloves',
    element: (
      <Suspense fallback={<PageLoader />}>
        <LabGloves />
      </Suspense>
    ),
  },
  {
    path: '/industrial-gloves',
    element: (
      <Suspense fallback={<PageLoader />}>
        <IndustrialGloves />
      </Suspense>
    ),
  },
  {
    path: '/bulk-wholesale',
    element: (
      <Suspense fallback={<PageLoader />}>
        <BulkWholesale />
      </Suspense>
    ),
  },
  {
    path: '/request-quote',
    element: (
      <Suspense fallback={<PageLoader />}>
        <RequestQuote />
      </Suspense>
    ),
  },
  {
    path: '/privacy-policy',
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivacyPolicy />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<PageLoader />}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;
